export const adminPermissions = [
  {
    key: 'impersonation',
    label: 'Impersonation',
    description: 'Log in as any member of any workspace to use the app exactly as they see it.',
  },
  {
    key: 'workspaces',
    label: 'Workspace Administration',
    description:
      'Change live workspace and member data — status, trials, billing, project moves, demo data, and member status.',
  },
  {
    key: 'ai',
    label: 'AI',
    description: 'View the AI dashboard analytics and replay AI conversations across all workspaces.',
  },
  {
    key: 'admins',
    label: 'Manage Administrators',
    description: 'Create, edit, and delete administrators and the permissions granted to them.',
  },
  {
    key: 'traces',
    label: 'Traces',
    description:
      'Inspect operation traces, entity change history, and outbound notifications across all workspaces in Trace, Entity, and Notification Replay.',
  },
];
